import CustomerServiceDropdownLists from './CustomerServiceDropdownLists.vue';
import FinanceDropdownList from "./FinanceDropdownList.vue";
export default {
	CustomerServiceDropdownLists,
	FinanceDropdownList,
};
